import {omneticApi} from '@dms/api/base';
import {UuidResponseBody, UuidResponseBodySchema} from '@dms/api/shared';

import {
  AddCustomerRequestApiArg,
  AddCustomerRequestRequestBodySchema,
  CustomerInquiryResponseBody,
  CustomerInquiryResponseBodySchema,
  CustomerInquiryVehicleDetailsSchema,
  CustomerInquiryVehicleInformationSchema,
  GetCustomerInquiryApiArg,
  RemoveCustomerRequestApiArg,
  UpdateCustomerRequestApiArg,
  UpdateCustomerRequestRequestBodySchema,
  UpdateVehicleDetailsApiArg,
  UpdateVehicleInformationApiArg,
} from './types';

const injected = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    getCustomerInquiry: build.query<CustomerInquiryResponseBody, GetCustomerInquiryApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/workshop/interest/${queryArg.interestId}/customer-inquiry`,
        queryArg,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'WorkshopInterest', id: queryArg.interestId},
      ],
      extraOptions: {
        responseSchema: CustomerInquiryResponseBodySchema,
      },
    }),

    updateWorkshopInterestVehicleDetails: build.mutation<void, UpdateVehicleDetailsApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/workshop/interest/${queryArg.interestId}/customer-inquiry/vehicle-details`,
        method: 'PUT',
        body: queryArg.updateVehicleDetailsRequestBody,
        queryArg,
      }),
      extraOptions: {
        requestSchema: CustomerInquiryVehicleDetailsSchema,
      },
    }),

    updateWorkshopInterestVehicleInformation: build.mutation<void, UpdateVehicleInformationApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/workshop/interest/${queryArg.interestId}/customer-inquiry/vehicle-information`,
        method: 'PUT',
        body: queryArg.updateVehicleInformationRequestBody,
        queryArg,
      }),
      extraOptions: {
        requestSchema: CustomerInquiryVehicleInformationSchema,
      },
    }),

    addCustomerRequest: build.mutation<UuidResponseBody, AddCustomerRequestApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/workshop/interest/${queryArg.interestId}/customer-inquiry/customer-request`,
        method: 'POST',
        body: queryArg.addCustomerRequestRequestBody,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'WorkshopInterest', id: queryArg.interestId},
      ],
      extraOptions: {
        requestSchema: AddCustomerRequestRequestBodySchema,
        responseSchema: UuidResponseBodySchema,
      },
    }),

    updateCustomerRequest: build.mutation<void, UpdateCustomerRequestApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/workshop/interest/${queryArg.interestId}/customer-inquiry/customer-request/${queryArg.customerRequestId}`,
        method: 'PUT',
        body: queryArg.updateCustomerRequestRequestBody,
        queryArg,
      }),
      extraOptions: {
        requestSchema: UpdateCustomerRequestRequestBodySchema,
      },
    }),

    removeCustomerRequest: build.mutation<void, RemoveCustomerRequestApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/workshop/interest/${queryArg.interestId}/customer-inquiry/customer-request/${queryArg.customerRequestId}`,
        method: 'DELETE',
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'WorkshopInterest', id: queryArg.interestId},
      ],
    }),
  }),
});

export const {
  useGetCustomerInquiryQuery,
  useUpdateWorkshopInterestVehicleDetailsMutation,
  useUpdateWorkshopInterestVehicleInformationMutation,
  useAddCustomerRequestMutation,
  useUpdateCustomerRequestMutation,
  useRemoveCustomerRequestMutation,
} = injected;
